/**
 * Map OrganisationSize enum values to HubSpot's expected label values.
 * Returns undefined if no size provided (field will be omitted).
 */
export function mapOrganisationSizeToHubSpot(
  size: string | null | undefined
): string | undefined {
  switch (size) {
    case 'JUST_ME':
      return 'Individual';
    case 'TWO_TO_FIVE':
      return '2-5';
    case 'SIX_TO_TWENTY':
      return '6-20';
    case 'TWENTY_ONE_TO_FIFTY':
      return '21-50';
    case 'FIFTY_ONE_PLUS':
      return '51-500';
    case 'FIVEHUNDREDPLUS':
      return '501+';
    default:
      return undefined;
  }
}
